import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageIntro from '../components/PageIntro';
import InboxMock from '../components/InboxMock';
import FeeNotice from '../components/FeeNotice';

const Services: React.FC = () => {
  useEffect(() => { document.title = 'How it works — Haven Crest Health'; }, []);
  return (
    <main>
      <PageIntro
        eyebrow="How it works"
        title={<>Care coordination, <em>with the paperwork built in.</em></>}
        lede="A navigator does the coordinating; your Haven Crest inbox is where it happens. It works like any email account, with the healthcare buttons added: a Request button that sends records requests on your behalf, a tracker for each one, and a person on the other end who follows up, explains, and helps you decide."
      />

      <section className="section">
        <div className="wrap grid grid--split">
          <div>
            <div className="eyebrow">What's in the box</div>
            <div className="grid" style={{ gap: '1.2rem' }}>
              <div className="card">
                <h3>📬 Your own health inbox</h3>
                <p>A dedicated @havencresthealth.com address, free, that you keep for as long as you want.</p>
                <ul><li>Send and receive email like any other account</li><li>Give it to doctors' offices, labs, and pharmacies</li><li>Everything medical in one place, separate from your personal mail</li></ul>
              </div>
              <div className="card">
                <h3>↗ One-click records requests</h3>
                <p>Pick a provider, click Request, and we do the rest on your behalf.</p>
                <ul><li>We prepare the request and the authorization for you to sign</li><li>We send it to the right department, by fax, portal, or mail</li><li>We follow up with the office when it stalls</li><li>Records arrive in your inbox, one folder per provider</li></ul>
              </div>
              <div className="card">
                <h3>◎ A tracker for every request</h3>
                <p>No more wondering whether an office got your fax.</p>
                <ul><li>Sent · Office received · Preparing · In your inbox</li><li>What the office told us when we called, in plain words</li><li>Any fee the office says applies, before it's charged to you</li></ul>
              </div>
              <div className="card">
                <h3>☺ Care navigation</h3>
                <p>People who help you understand your records and decide what to do next.</p>
                <ul><li>Plain-language summaries of what your records say</li><li>Help finding a doctor or specialist, including for a second opinion</li><li>Getting organized before an appointment</li><li>Extra depth in <Link to="/nutrition">nutrition</Link>, <Link to="/oncology">cancer care</Link>, and <Link to="/cardiovascular">heart health</Link></li></ul>
              </div>
            </div>
          </div>
          <div style={{ position: 'sticky', top: '96px' }}><InboxMock /></div>
        </div>
      </section>

      <section className="section section--rule">
        <div className="wrap">
          <div className="eyebrow">What it costs</div>
          <h2 className="measure">Nothing from us. Here's the long version, because we'd rather you never be surprised.</h2>
          <div className="grid grid--2" style={{ marginTop: '2.5rem' }}>
            <div className="card">
              <h3>Haven Crest is free</h3>
              <p>The inbox, the requests, the follow-up calls, the tracker, and the navigation help are all free. There is no plan to upgrade to and no invoice from us. Using it is voluntary, and you can close your account whenever you like.</p>
            </div>
            <FeeNotice />
          </div>
        </div>
      </section>

      <section className="section section--rule">
        <div className="wrap center">
          <h2>Ready for an inbox that works for you?</h2>
          <p className="lede">It's free, it's yours, and the first records request is one click away.</p>
          <Link to="/contact" className="btn btn--accent">Get an advocate, free <span className="arrow">→</span></Link>
        </div>
      </section>
    </main>
  );
};

export default Services;
